var map = {
	"./cloudy-day-1.svg": 29,
	"./cloudy-day-2.svg": 30,
	"./cloudy-day-3.svg": 31,
	"./cloudy-night-1.svg": 32,
	"./cloudy-night-2.svg": 33,
	"./cloudy-night-3.svg": 34,
	"./cloudy.svg": 35,
	"./day.svg": 36,
	"./night.svg": 37,
	"./rainy-1.svg": 38,
	"./rainy-2.svg": 39,
	"./rainy-3.svg": 40,
	"./rainy-4.svg": 41,
	"./rainy-5.svg": 42,
	"./rainy-6.svg": 43,
	"./rainy-7.svg": 44,
	"./snowy-1.svg": 45,
	"./snowy-2.svg": 46,
	"./snowy-3.svg": 47,
	"./snowy-4.svg": 48,
	"./snowy-5.svg": 49,
	"./snowy-6.svg": 50,
	"./thunder.svg": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;